import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { WhipLogo } from "@/components/WhipLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data.user);
        navigate("/", { replace: true, state: { user: data.user } });
      } catch (e) {
        const msg = formatApiErrorDetail(e.response?.data?.detail) || "Google sign-in failed";
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true, state: { error: msg } });
      }
    })();
    // Intentionally run once on mount (guarded by hasProcessed ref).
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" style={{ background: "var(--whip-bg, #0b0b0f)" }}>
      <WhipLogo size={32} />
      <p className="text-white/60 text-sm font-mono uppercase tracking-widest" data-testid="auth-callback-status">
        {error || "Completing sign-in…"}
      </p>
    </div>
  );
};
